import type { I18nDictionaryShape } from '../../types';
import type { commonEnGb } from '../en-GB/common';

export const commonEsEs = {
  brand: {
    logoAlt: 'Logotipo de Safi',
    name: 'Safi',
    vatLabel: 'IVA de Safi',
  },
  domains: {
    evidence: 'Evidencia',
    evidenceLower: 'evidencia',
    qualityControl: 'Control de calidad',
    qualityControlLower: 'control de calidad',
  },
  currencySelectField: {
    groups: {
      other: 'Otras',
      suggested: 'Sugeridas',
    },
  },
} satisfies I18nDictionaryShape<typeof commonEnGb>;
